export function isValidIMONumber(imo: string): boolean {
  // Ensure the input is exactly 7 digits long
  if (!/^\d{7}$/.test(imo)) {
    return false;
  }

  // Extract the first 6 digits
  const firstSixDigits = imo.slice(0, 6);

  // Calculate the check digit
  let sum = 0;
  for (let i = 0; i < 6; i++) {
    const digit = parseInt(firstSixDigits[i], 10);
    sum += digit * (7 - i);
  }
  const checkDigit = sum % 10;

  // Validate the last digit against the check digit
  return checkDigit === parseInt(imo[6], 10);
}
